import { render, staticRenderFns } from "./IndividualInsightsTrendTable.vue?vue&type=template&id=49e5f64f"
import script from "./IndividualInsightsTrendTable.vue?vue&type=script&lang=js"
export * from "./IndividualInsightsTrendTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports